// @ts-nocheck
import { workerService } from '@/services';
export default {
    async putWorkers({ state }, payload) {
        try {
            const requestList = state.selectedBulkEditWorkerCodeList
                .map((code) => workerService.putWorkers({
                code,
                newData: {
                    ...payload,
                },
            }));
            const responseList = await Promise.allSettled(requestList);
            const isResponseAllSuccess = responseList
                .every(({ status }) => status === 'fulfilled');
            let workerCodeList = null;
            if (!isResponseAllSuccess) {
                // TODO 현재는 실패한 라이더 코드만 스낵바에 보여주도록 함, 기획 방향 잡히면 그에 맞게 추후 수정 필요
                workerCodeList = responseList
                    .map(({ status }, idx) => {
                    if (status === 'rejected') {
                        return state.selectedBulkEditWorkerCodeList[idx];
                    }
                    return null;
                });
            }
            return {
                isSuccess: isResponseAllSuccess,
                reason: workerCodeList,
            };
        }
        catch (error) {
            const message = error.response?.data.error.message ?? error.message;
            const reason = error.response?.data.error.reason ?? error.reason;
            console.log('[putWorkers] ', e, message, reason);
            return {
                isSuccess: false,
                message,
                reason,
            };
        }
    },
    setWorkerBulkEditDialogOpen({ commit }, isOpen = true) {
        commit('SET_WORKER_MANAGEMENT_BULK_EDIT_DIALOG_OPEN', isOpen);
    },
    setSelectedBulkEditWorkerCodeList({ commit }, selectedWorkerList) {
        const selectedCodeList = selectedWorkerList.map(({ code }) => code);
        commit('SET_SELECTED_BULK_EDIT_WORKER_CODE', selectedCodeList);
    },
};
